// src/pages/LoginPage.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useApi } from '../hooks/useApi';
import logoLogin from '../assets/beo-logo-login.png';

export default function LoginPage({ onLogin, showToast }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const { request, loading } = useApi();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) return;
    try {
      const { token } = await request('/api/login', {
        method: 'POST',
        body: JSON.stringify({ username, password, rememberMe }),
      });
      onLogin(token);
      showToast('Login successful', 'success');
    } catch (err) {
      showToast(err.message || 'Login failed', 'error');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-image animate-fade-in-left">
        <div className="auth-image-content">
          <img src={logoLogin} alt="BEO IT Operations Logo" style={{ width: '100%', maxWidth: '310px', marginBottom: '8px', filter: 'drop-shadow(0 0 15px hsla(0, 0%, 100%, 0.20))', transform: 'translateY(-4px)' }} />
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', margin: '0 0 12px 0', letterSpacing: '0.02em', color: '#ebf2faff', lineHeight: 1.3 }}>
            Smarter Support,<br />
            <span style={{ color: 'var(--text-60a5fa)' }}>Faster Resolutions</span>
          </h1>
          <p className="auth-subtitle-text" style={{ margin: '0 0 24px 0', opacity: 0.85, fontSize: '1.05rem', lineHeight: 1.5, maxWidth: '340px' }}>
            AI-assisted helpdesk that understands, automates, and resolves issues—so your team can focus on what matters.
          </p>
          <div className="auth-badges">
            <div className="auth-badge-card premium-badge">
              <div className="auth-badge-title">Fast</div>
              <div className="auth-badge-sub">Instant resolution</div>
            </div>
            <div className="auth-badge-card premium-badge">
              <div className="auth-badge-title">Smart</div>
              <div className="auth-badge-sub">AI-powered automation</div>
            </div>
            <div className="auth-badge-card premium-badge">
              <div className="auth-badge-title">Secure</div>
              <div className="auth-badge-sub">Enterprise-grade security</div>
            </div>
          </div>
        </div>
      </div>
      <div className="auth-form-card animate-slide-up-right">
        <form className="auth-card" onSubmit={handleSubmit}>
          <h2>Sign In</h2>
          <p className="auth-subtitle">Welcome! Please enter your details.</p>

          {useLocation().search.includes('redirect=/tickets/') && (
            <div style={{ background: 'rgba(245, 158, 11, 0.1)', border: '1px solid rgba(245, 158, 11, 0.2)', padding: '12px 16px', borderRadius: '8px', marginBottom: '20px', fontSize: '13px', color: '#f59e0b', lineHeight: 1.5 }}>
              <strong>Access Required:</strong> You are attempting to view a secure ticket. Please log in with your platform account. If you are an external watcher, please contact your IT administrator.
            </div>
          )}

          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            marginBottom: '24px',
            cursor: 'pointer',
            justifyContent: 'flex-start',
            width: '100%'
          }}>
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                style={{
                  width: '18px',
                  height: '18px',
                  cursor: 'pointer',
                  accentColor: 'var(--brand)',
                  borderRadius: '4px',
                  border: '1px solid var(--white-20)',
                  background: 'var(--black-30)'
                }}
              />
              <label htmlFor="rememberMe" style={{
                margin: 0,
                fontSize: '0.85rem',
                opacity: 0.85,
                cursor: 'pointer',
                userSelect: 'none',
                color: 'var(--text-primary)',
                fontWeight: '400',
                letterSpacing: '0.01em',
                paddingLeft: '10px'
              }}>
                Keep me logged in for 30 days
              </label>
            </div>

          </div>

          <button className="btn btn-primary w-full" type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Sign In'}
          </button>

          {/* <div className="auth-footer">
            Don't have an account? <Link to="/register">Register here</Link>
          </div> */}
        </form>
      </div >
    </div >
  );
}
